/**
 * Composer image attach (paperclip) for vision-capable chat models (optional reference image).
 */
export function isVisionPaperclipComposerModel(modelId: string): boolean {
  const id = String(modelId || '').toLowerCase().trim();
  if (!id) return false;
  if (id.startsWith('gemini')) return true;
  if (id.startsWith('chatgpt') || id.startsWith('minichatgpt')) return true;
  if (id.includes('haiku')) return true;
  if (id.startsWith('pixtral')) return true;
  if (id.startsWith('pegasus') || id.startsWith('pegusus')) return true;
  return false;
}
